(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const searchButton = document.querySelector('[data-search-toggle]');
  const searchRow = document.querySelector('[data-search-row]');
  const body = drawer?.querySelector('[data-drawer-body]');
  let opener = null, pending = false, previousOverflow = '', currency = 'NZD';
  const inertStates = new Map();
  let messages = {};
  try { messages = JSON.parse(document.getElementById('CGUiStrings')?.textContent || '{}'); } catch (_) {}
  function toast(message) {
    const element = document.getElementById('toast');
    if (!element) return;
    element.textContent = message; element.classList.add('show');
    clearTimeout(element.cgTimer);element.cgTimer=setTimeout(()=>element.classList.remove('show'),4200);
  }
  window.cgToast=toast;
  const money=amount=>new Intl.NumberFormat(document.documentElement.lang || 'en-NZ',{style:'currency',currency}).format(Number(amount)/100);
  function node(tag,className,text) {const el=document.createElement(tag);if(className)el.className=className;if(text!==undefined)el.textContent=text;return el;}
  function message(text){if(body)body.replaceChildren(node('p','drawer-empty',text));}
  function openDrawer(trigger) {
    if(!drawer)return;
    if(!drawer.classList.contains('open')){
      opener=trigger||document.activeElement;previousOverflow=document.body.style.overflow;
      [...document.body.children].forEach(el=>{if(el===drawer||el===overlay||el.id==='toast'||['SCRIPT','STYLE','TEMPLATE','LINK'].includes(el.tagName))return;inertStates.set(el,el.inert);el.inert=true;});
      document.body.style.overflow='hidden';
    }
    drawer.inert=false;drawer.classList.add('open');drawer.setAttribute('aria-hidden','false');overlay?.classList.add('open');
    drawer.querySelector('[data-drawer-close]')?.focus();
  }
  function closeDrawer(){
    if(!drawer?.classList.contains('open'))return;
    drawer.classList.remove('open');drawer.setAttribute('aria-hidden','true');drawer.inert=true;overlay?.classList.remove('open');
    inertStates.forEach((value,el)=>{el.inert=value;});inertStates.clear();document.body.style.overflow=previousOverflow;
    if(opener instanceof HTMLElement && opener.isConnected)opener.focus();
  }
  if(drawer)drawer.inert=true;
  function safeImage(source){try{const url=new URL(source,location.origin);return ['https:','http:'].includes(url.protocol)?url.href:'';}catch(_){return '';}}
  function renderCart(cart){
    if(!body||!cart||!Array.isArray(cart.items))throw new Error(messages.error||'Cart unavailable.');
    if(/^[A-Z]{3}$/.test(cart.currency||''))currency=cart.currency;
    document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=String(cart.item_count);el.style.display=cart.item_count?'grid':'none';});
    const fragment=document.createDocumentFragment();
    if(!cart.item_count)fragment.append(node('div','drawer-empty',messages.empty||'Your cart is empty.'));
    cart.items.forEach(item=>{
      const line=node('div','cart-line');line.dataset.lineKey=item.key;line.dataset.quantity=String(item.quantity);
      const imageUrl=safeImage(item.featured_image?.url||item.image||'');
      if(imageUrl){const image=node('img');image.src=imageUrl;image.alt=item.featured_image?.alt||item.product_title||'';image.width=72;image.height=72;image.loading='lazy';line.append(image);}
      const info=node('div','line-info');
      const title=node('a','line-title',item.product_title||item.title||'');
      try{const url=new URL(item.url,location.origin);if(url.origin===location.origin)title.href=url.pathname+url.search;}catch(_){}
      info.append(title);
      if(item.variant_title&&item.variant_title!=='Default Title')info.append(node('div','line-variant',item.variant_title));
      const controls=node('div','line-qty');
      const minus=node('button','', '−');minus.type='button';minus.dataset.lineDelta='-1';minus.setAttribute('aria-label',(messages.less||'Decrease quantity')+': '+item.product_title);
      const plus=node('button','', '+');plus.type='button';plus.dataset.lineDelta='1';plus.setAttribute('aria-label',(messages.more||'Increase quantity')+': '+item.product_title);
      controls.append(minus,node('span','',String(item.quantity)),plus);info.append(controls);
      const price=node('div','line-price',money(item.final_line_price));line.append(info,price);fragment.append(line);
    });
    body.replaceChildren(fragment);
    const total=drawer.querySelector('[data-drawer-subtotal],[data-cart-subtotal]');if(total)total.textContent=money(cart.total_price);
    const checkout=drawer.querySelector('[data-drawer-checkout]');if(checkout)checkout.disabled=!cart.item_count;
  }
  async function request(path,options={}){
    const response=await fetch(root+path,{credentials:'same-origin',...options,headers:{Accept:'application/json',...(options.headers||{})}});
    const data=await response.json();
    if(!response.ok)throw new Error(typeof data.description==='string'?data.description:messages.error||'Please check your cart and try again.');
    return data;
  }
  async function refresh(){const cart=await request('cart.js');renderCart(cart);return cart;}
  async function viewCart(trigger){
    if(pending)return;
    pending=true;openDrawer(trigger);message(messages.loading||'Loading your cart…');
    const checkout=drawer?.querySelector('[data-drawer-checkout]');if(checkout)checkout.disabled=true;
    try{await refresh();}catch(error){message(messages.error||'Your cart could not be loaded. Use View cart to continue.');toast(messages.error||error.message);}finally{pending=false;}
  }
  document.addEventListener('click',async event=>{
    if(!(event.target instanceof Element))return;
    const trigger=event.target.closest('[data-cart-open]');
    if(trigger){event.preventDefault();if(document.querySelector('.cart-page')){location.assign(root+'cart');return;}await viewCart(trigger);return;}
    if(event.target.closest('[data-drawer-close]')||event.target===overlay){closeDrawer();return;}
    const checkout=event.target.closest('[data-drawer-checkout]');
    if(checkout){if(!checkout.disabled&&!pending)location.assign(root+'checkout');return;}
    const control=event.target.closest('[data-line-delta]');
    if(control){
      if(pending)return;
      const line=control.closest('[data-line-key]');if(!line)return;
      const quantity=Math.max(0,Number(line.dataset.quantity)+Number(control.dataset.lineDelta));
      pending=true;const checkoutButton=drawer.querySelector('[data-drawer-checkout]');if(checkoutButton)checkoutButton.disabled=true;drawer.querySelectorAll('[data-line-delta]').forEach(button=>button.disabled=true);
      try{renderCart(await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.dataset.lineKey,quantity})}));}
      catch(error){toast(error.message||messages.error);try{await refresh();}catch(_){message(messages.error||'Please use View cart to continue.');}}
      finally{pending=false;drawer.querySelectorAll('[data-line-delta]').forEach(button=>button.disabled=false);}
    }
  });
  menuButton?.addEventListener('click',()=>{const open=menu?.classList.toggle('open');menuButton.setAttribute('aria-expanded',String(!!open));});
  searchButton?.addEventListener('click',()=>{const open=searchRow?.classList.toggle('open');searchButton.setAttribute('aria-expanded',String(!!open));if(open)searchRow.querySelector('input')?.focus();});
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'){
      if(drawer?.classList.contains('open')){closeDrawer();return;}
      if(searchRow?.classList.contains('open')){searchRow.classList.remove('open');searchButton?.setAttribute('aria-expanded','false');searchButton?.focus();}
      if(menu?.classList.contains('open')){menu.classList.remove('open');menuButton?.setAttribute('aria-expanded','false');menuButton?.focus();}
    }
    if(event.key==='Tab'&&drawer?.classList.contains('open')){
      const focusable=[...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length);
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  const header=document.querySelector('[data-header]');let frame=0;
  const onScroll=()=>{if(!frame)frame=requestAnimationFrame(()=>{header?.classList.toggle('compact',window.scrollY>48);frame=0;});};
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
})();
